import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Modal, Typography } from '@mui/material';
import React from 'react';
import { scoringItems } from '../Contents/scoringContent';

interface ScoringSystemModalProps {
  open: boolean;
  onClose: () => void;
}

const ScoringSystemModal: React.FC<ScoringSystemModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="scoring-system-modal">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: '600px',
          bgcolor: 'rgba(20, 20, 20, 0.95)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '8px',
          p: 4,
          color: 'white',
          maxHeight: '90vh',
          overflow: 'auto',
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'white',
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          variant="h5"
          sx={{
            fontFamily: 'Bebas Neue',
            fontSize: 'clamp(1.4rem, 2.5vw, 1.8rem)',
            mb: 3,
            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
            pb: 1,
          }}
        >
          Scoring System Breakdown
        </Typography>
        {scoringItems.map((item, index) => (
          <Box key={index} sx={{ mb: 3 }}>
            <Box
              sx={{
                position: 'relative',
                mb: 2,
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: '-8px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '80%',
                  height: '1px',
                  backgroundImage:
                    'linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0))',
                },
              }}
            >
              <Typography
                sx={{
                  textAlign: 'center',
                  textTransform: 'uppercase',
                  fontSize: 'clamp(0.8rem, 1.8vw, 1.2rem)',
                }}
              >
                <strong>{item.title}</strong>
              </Typography>
            </Box>
            {item.points.map((point, pointIndex) => (
              <Typography
                key={pointIndex}
                sx={{
                  textAlign: 'center',
                  fontSize: 'clamp(0.7rem, 1.2vw, 0.8rem)',
                }}
              >
                <strong>{point.value}</strong> {point.description}
              </Typography>
            ))}
          </Box>
        ))}
      </Box>
    </Modal>
  );
};

export default ScoringSystemModal;
